module.exports = __webpack_public_path__ + "img/1723086006845-WhatsApp Image 2024-08-07 at 16.38.13.jpeg.98bd0bec.webp";